import React from 'react';
import { Chip, Box, Typography } from '@mui/material';

const MenuAnalysisChip = ({
  item,
  type = 'alternative', // 'alternative', 'avoid', 'best'
  compact = false,
  index,
  isMobile = false,
}) => {
  const getChipStyles = (type) => {
    switch (type) {
      case 'best':
        return {
          backgroundColor: '#e8f5e8',
          color: '#26786A',
          border: '1px solid #26786A',
        };
      case 'alternative':
        return {
          backgroundColor: '#e3f2fd',
          color: '#2196F3',
          border: '1px solid #2196F3',
        };
      case 'avoid':
        return {
          backgroundColor: '#ffebee',
          color: '#f44336',
          border: '1px solid #f44336',
        };
      default:
        return {
          backgroundColor: '#f5f5f5',
          color: '#666',
          border: '1px solid #e0e0e0',
        };
    }
  };

  const getJustificationText = () => {
    if (type === 'best' && item.justification) {
      return item.justification;
    }
    if (type === 'alternative' && item.justification) {
      return item.justification;
    }
    if (type === 'avoid' && item.reason) {
      return item.reason;
    }
    return null;
  };

  return (
    <Box
      key={index}
      style={{
        marginBottom: compact ? '4px' : isMobile ? '8px' : '12px',
        width: isMobile ? '100%' : 'auto',
      }}
    >
      <Chip
        label={item.item_name}
        size={isMobile ? 'medium' : 'small'}
        style={{
          ...getChipStyles(type),
          width: isMobile ? '100%' : 'auto',
          justifyContent: 'flex-start',
          height: isMobile ? '40px' : 'auto',
        }}
      />
      {!compact && getJustificationText() && (
        <Typography
          variant="body2"
          style={{
            color: '#666',
            fontSize: isMobile ? '0.75rem' : '0.875rem',
            marginTop: '4px',
            lineHeight: '1.4',
            paddingLeft: isMobile ? '8px' : '0',
          }}
        >
          {getJustificationText()}
        </Typography>
      )}
    </Box>
  );
};

export default MenuAnalysisChip;
